import { useCallback, useMemo, useState } from 'react';

/**
 * @deprecated Use the useDialog hook instead
 */
export const useModal = (initialMode = false) => {
  const [isVisible, setVisible] = useState<boolean>(initialMode);

  const open = useCallback(() => setVisible(true), []);
  const close = useCallback(() => setVisible(false), []);

  return useMemo(() => ({ isVisible, open, close }), [isVisible, open, close]);
};
